<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="contents-wrapper">
    <div class="contents-container">
      <div class="installments-container">
        <ng-container
          *ngFor="let loanOption of presentedLoanOptions; let i = index"
        >
          <app-installments-item
            [isFirstItem]="i === 0"
            [isLastItem]="
              i === availableLoanOptions.length - 1 &&
              equalOrLessThanThreeLoanOptions
            "
            [title]="loanOption.title"
            [selected]="loanOption === selectedLoanOption"
            (click)="
              loanOption !== selectedLoanOption && selectInstallment(loanOption)
            "
            [bulletPoints]="loanOption.bulletPoints"
            [link]="loanOption.link"
            [radioButtonColor]="loanOption.radioButtonColor"
            [color]="loanOption.color"
            [badgeText]="loanOption.badgeText"
          ></app-installments-item>
        </ng-container>
        <button
          *ngIf="!equalOrLessThanThreeLoanOptions"
          class="installments-button"
          (click)="expanded ? viewReducedLoanOptions() : viewAllLoanOptions()"
        >
          {{ expanded ? 'Vis mindre' : 'Vis mer' }}
          <img
            style="margin-left: 4px; display: inline-block"
            [src]="
              expanded
                ? 'assets/icon/Arrow-Up.svg'
                : 'assets/icon/Arrow-Down.svg'
            "
          />
        </button>
      </div>
      <div class="bottom-secetion-wrapper">
        <div class="pr-info">
          <label>Totalbeløp</label>
          <label>
            {{ state.totalCheckoutValue | value }}
          </label>
        </div>

        <div class="button-container">
          <zaver-primary-button
            [text]="'Neste'"
            [disabled]="navigationInProgress || !selectedLoanOption"
            [loading]="navigationInProgress"
            (click)="handleCtaClick()"
          ></zaver-primary-button>
        </div>

        <p *ngIf="currentLoanTermsStr" class="loan-terms-string">
          Beregninger: {{ currentLoanTermsStr }}
        </p>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Lukk'"
  [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
  (onClose)="toggleModal()"
>
  <app-selector
    #selector
    [selectorItems]="selectorItems"
    [selectedItem]="selectorItems[1]"
  ></app-selector>
</zaver-checkout-modal>
